import { get, post } from '@/service/request';
import { requestOptions as options } from '@/service/requestOptions';

const url = 'api/MultiENotify';
// const options = { errorDialog: true, secure: false, baseURL: true, repeatRequestCancel: false };

// 取得申請電子通知單條款說明
export function getAgreeTermsMultiENotify() {
    return get(`${url}/getAgreeTerms`);
}

// 保戶進入申請電子通知單前，取得先前申請電子通知單記錄applyStatus: true:已申請, false:未申請
export function postAgreeMultiENotify() {
    return post(`${url}/agree`);
}

// 保戶進入申請電子通知單前，取得先前申請電子通知單記錄
export function getInfoMultiENotify() {
    return get(`${url}/info`);
}

// 送出此次電子通知單申請內容
export function submitMultiENotify(data) {
    return post(`${url}/submit`, data, { ...options, repeatRequestCancel: true });
}
